import React from 'react';
import { BadgeType, BadgeTier } from '../utils/badges';

interface BadgeIconProps {
  type: BadgeType;
  tier: BadgeTier;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  animate?: boolean;
}

const BadgeIcon: React.FC<BadgeIconProps> = ({ type, tier, size = 'medium', animate = false }) => {
  if (tier === BadgeTier.NONE) {
    // Render empty slot
    return (
      <div className={`badge-icon empty ${size}`}>
        <div className="badge-layer badge-slot-img" role="img" aria-label="Badge slot" />
      </div>
    );
  }

  // Map badge type to CSS class
  const colorClassMap = {
    [BadgeType.STREAK]: 'badge-color-1',
    [BadgeType.COMPLETION]: 'badge-color-2',
    [BadgeType.GENIUS]: 'badge-color-3',
  };

  // Map badge tier to CSS class
  const medalClassMap = {
    [BadgeTier.BRONZE]: 'badge-medal-bronze',
    [BadgeTier.SILVER]: 'badge-medal-silver',
    [BadgeTier.GOLD]: 'badge-medal-gold',
    [BadgeTier.NONE]: 'badge-medal-bronze', // Fallback (shouldn't be used)
  };

  return (
    <div className={`badge-icon ${tier} ${size} ${animate ? 'animate' : ''}`}>
      {/* Layer 1: Badge color (ribbon) - uses CSS variable --img-badge-color-N */}
      <div
        className={`badge-layer badge-color ${colorClassMap[type]}`}
        role="img"
        aria-label="Badge ribbon"
      />
      {/* Layer 2: Badge medal - uses CSS variable --img-badge-medal-{tier} */}
      <div
        className={`badge-layer badge-medal ${medalClassMap[tier]}`}
        role="img"
        aria-label="Badge medal"
      />
    </div>
  );
};

export default BadgeIcon;
